module.exports = __webpack_public_path__ + "static/media/tick.460157f3.svg";